export default "__VITE_ASSET__DimFn8WN__"